import React, { useEffect, useState, useRef } from 'react';
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useNavigate, useLocation } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
} from '@fortawesome/free-solid-svg-icons';

import WebNav from "../components/WebNav";
import Sidebar from "../components/Sidebar";
import "../styles/Style.css";

// Load Stripe
const stripePromise = loadStripe("pk_test_51QVkxVBFE0xHMrRPwES3pmNZYHbm7CZpOYmlTXm1f81iLg97GbLTHMzYN4ikDkRCfs08OJW4a6FS5jKyIjtXnrWJ00mC0h0tG1");
// Billing Form
const BillingForm = ({ clientSecret, isName, planId }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const planIdZ = planId;
    setLoading(true);

    if (!stripe || !elements) {
      setMessage("Stripe has not loaded yet.");
      setLoading(false);
      return;
    }

    const card = elements.getElement(CardElement);

    const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: card,
        billing_details: { name: isName || "User Name" },
      },
    });

    if (error) {
      setMessage(error.message);
    } else if (paymentIntent?.status === "succeeded") {
      setMessage("Payment successful!");

      // const form = e.target;
      // const planIdZ = form.plan_id.value;
      
      // Update user details in database
    //   console.log('paymentIntent',paymentIntent);
      const token = localStorage.getItem("token");
      fetch("https://qrkey.qrkey.info/api/users/update-payment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ paymentIntentId: paymentIntent.id, plan_id: planIdZ }),
      })
        .then((res) => res.json())
        .then((data) => {
            navigate("/create-qr");
        })
        .catch((error) => {
            console.error("Error updating user:", error);
        });
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-4">
        <input type="hidden" id="plan_id" value={planId}/>
        <label htmlFor="user-name" className="form-label">User Name</label>
        <input type="text" id="user-name" className="form-control" value={isName || ""} readOnly />
      </div>

      <div className="mb-4">
        <label htmlFor="card-element" className="form-label">Payment Method</label>
        <CardElement
          id="card-element"
          options={{
            style: {
              base: {
                fontSize: "16px",
                color: "#424770",
                "::placeholder": { color: "#aab7c4" },
              },
              invalid: { color: "#9e2146" },
            },
          }}
        />
      </div>

      <button
        type="submit"
        className="btn btn-primary w-100"
        disabled={!stripe || loading}
      >
        {loading ? "Processing..." : "Pay Now"}
      </button>
      {message && <div className="alert alert-info mt-3">{message}</div>}
    </form>
  );
};

const SubscriptionPage = () => {
  const [clientSecret, setClientSecret] = useState(null);
  const isMounted = useRef(false);
  const [isName, setIsName] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const planId = queryParams.get('plan');
  const savedPlanId = useRef(planId);

  useEffect(() => {
    if (!isMounted.current) {
        const token = localStorage.getItem("token");
        const payload = { planId: savedPlanId.current };
        fetch("https://qrkey.qrkey.info/api/users/create-payment-intent", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
        })
        .then((res) => res.json())
        .then((data) => {
            setClientSecret(data.clientSecret);
            setIsName(data.name);
        })
        .catch((error) => console.error("Error fetching client secret:", error));

        isMounted.current = true;
    }
  }, []);
  // Add/remove body class when the page loads/unloads
  useEffect(() => {
    document.body.classList.add('loged-body');
    return () => {
      document.body.classList.remove('loged-body');
    };
  }, []);

  const renderPrice = (id) => {
    switch (id) {
        case "1":
            return '25';
        case "2":
            return '50';
        case "3":
            return '100';
        case "4":
            return '1';
        default:
            return <p><strong>Total:</strong> Invalid Plan</p>;
    }
  }

  return (
    <>
      <Sidebar />
      <WebNav />
      <div className="container mt-4 user-panel-body">
        {!clientSecret ? (
          <div className="text-center">Loading...</div>
        ) : (
          <div className="row subscription">
            <div className="col-md-8">
              <div className="d-flex align-items-center mb-4">
                <button 
                    className="btn btn-danger" 
                    onClick={() => window.history.back()} 
                    style={{ padding: '5px 10px', marginRight: '10%', }}
                >
                  <FontAwesomeIcon icon={faArrowLeft} className="me-4" />
                  Go Back
                </button>
                <h3>Billing Information</h3>
                
            </div>
              <Elements stripe={stripePromise} options={{ clientSecret }}>
                <BillingForm clientSecret={clientSecret} isName={isName} planId={planId} />
              </Elements>
            </div>
            <div className="col-md-4">
              <div className="card">
                <div className="card-header bg-primary text-white">
                  <h4 className="m-0 text-white">Summary</h4>
                </div>
                <div className="card-body">
                  <p><strong>Plan:</strong> 12 Months Plan</p>
                  <p><strong>Total:</strong> €{renderPrice(planId)} </p>
                  <h5>Features:</h5>
                  <ul>
                    <li>Create {renderPrice(planId)} dynamic contact page</li>
                    <li>Unlimited scans</li>
                    <li>Multiple downloads</li>
                    <li>Activate/deactivate anytime</li>
                    <li>Delete anytime</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SubscriptionPage;
